import React from "react";
import PropTypes from "prop-types";

export default function ApprovalStatus({ approved, restricted }) {
  if (approved) {
    return (
      <span className="text-success">
        <i className="fa fa-check" />
        &nbsp;Approved
      </span>
    );
  }

  return restricted ? (
    <span className="text-warning">
      <i className="fa fa-ban" />
      &nbsp;Export Preapproval Req&apos;d
    </span>
  ) : null;
}

ApprovalStatus.propTypes = {
  approved: PropTypes.bool,
  restricted: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/ApprovalStatus.jsx